import { SlotEvent } from "../DragNDropCalendar";
import Event from "./Event";

type CustomProps = {
  onDeleteClick: (event: SlotEvent) => void;
};

type Props = {
  event: SlotEvent;
};

const CustomEventWithProps = ({ onDeleteClick }: CustomProps) => {
  return (props: Props) => {
    return <Event {...props} onDelete={onDeleteClick} />;
  };
};

export default CustomEventWithProps;
